import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { CompanyAnnouncementsComponent } from "./company-announcements/company-announcements.component";
import { Routes, RouterModule } from "@angular/router";
import { FormsModule } from "@angular/forms";
import { IconsModule } from "@va/core-library/icons";

import { MatTableModule } from "@angular/material/table";
import { MatButtonModule } from "@angular/material/button";
import { MatSortModule } from "@angular/material/sort";
import { MatSelectModule } from "@angular/material/select";
import { MatMenuModule } from "@angular/material/menu";
import { MatSnackBarModule } from "@angular/material/snack-bar";

const CompanyAnnouncementsRoutes: Routes = [
  {
    path: "",
    component: CompanyAnnouncementsComponent,
    data: {
      title: "Company Announcements",
    },
  },
  {
    path: "**",
    redirectTo: "/home",
  },
];
@NgModule({
  imports: [RouterModule.forChild(CompanyAnnouncementsRoutes)],
  exports: [RouterModule],
})
export class CompanyAnnouncementsPageRoutingModule {}

@NgModule({
  declarations: [CompanyAnnouncementsComponent],
  imports: [
    CommonModule,
    FormsModule,
    IconsModule,
    CompanyAnnouncementsPageRoutingModule,
    MatTableModule,
    MatButtonModule,
    MatSortModule,
    MatMenuModule,
    MatSelectModule,
    MatSnackBarModule,
  ],
  exports: [],
})
export class CompanyAnnouncementsPageModule {}
